import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'

const ComplianceUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  status, onStatusChange, statusError, setStatusError, statusList,
  remarks, onRemarksChange, remarksError, setRemarksError,
  cureDate, onCureDateChange, cureDateError, setCureDateError,
  // penaltyStatus, onPenaltyStatusChange, penaltyStatusError, setPenaltyStatusError, penaltyStatusList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update status'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF
      type='select' name='status' label='Status'
      value={status} onChange={onStatusChange} optionList={statusList}
      error={statusError} setError={setStatusError}
    />

    <InputTextSF
      type='text' name='remarks' label='Remarks'
      value={remarks} onChange={onRemarksChange}
      error={remarksError} setError={setRemarksError}
    />
    
    {status === 'complied' && (
      <InputDateUI 
        type='date' 
        name='cureDate' 
        label='Cure date'
        context={context}
        selectedDateISO={cureDate} 
        onChange={onCureDateChange}
        error={cureDateError} 
        setError={setCureDateError}
      />
    )}

    {/* <InputSelectSF
      type='select' name='penaltyStatus' label='Penalty Status'
      value={penaltyStatus} onChange={onPenaltyStatusChange} optionList={penaltyStatusList}
      error={penaltyStatusError} setError={setPenaltyStatusError}
    /> */}

  </ModalFormUI>

export default ComplianceUpdateModalUI